<ng-container [ngTemplateOutlet]="buttonMode ? isButtonMode : isTextBoxMode"></ng-container>

<ng-template #isButtonMode>
    <dx-button [text]="SearchBtnText" (click)="showSearch()" class="ocl-width-120" [disabled]="disabled"></dx-button>
</ng-template>

<ng-template #isTextBoxMode>
    <div fxLayout="row" fxLayoutAlign="space-between">
        <div class="dx-field">
            <div class="dx-field-label" style="width: 100%">Patient</div>
            <div class="dx-field-value">
                <dx-button
                    id="clear-btn"
                    icon="clear"
                    *ngIf="selectedPatient !== undefined && selectedPatient !== null"
                    (click)="clear()"
                ></dx-button>
                <dx-text-box
                    class="uppercase"
                    [readOnly]="true"
                    [value]="PatientFullName"
                    [style.border-bottom-left-radius]="!selectedPatient ? '4px' : 0"
                    [style.border-top-left-radius]="!selectedPatient ? '4px' : 0"
                ></dx-text-box>
                <dx-button id="search-btn" icon="search" (click)="showSearch()"></dx-button>
                <app-patient-info-popup [selectedPatient]="selectedPatient"></app-patient-info-popup>
            </div>
        </div>
    </div>
</ng-template>

<app-patient-selector-dialog
    [popupVisible]="isPopupVisible"
    [fromSearch]="!buttonMode"
    (closeEvent)="closeDialog($event)"
></app-patient-selector-dialog>
